import { ASK, ASK_SUMMARIES, useFeatureFlag } from '@shared/util/featureFlags';

/**
 * Whether the inline "Summarize" widgets (card-level and subform-level) are available.
 *
 * Gated on its own flag rather than on `ASK` alone: `ASK` turns on the Ask panel, and
 * the summarize buttons are a separate surface that embeds itself in the card form, so
 * an org piloting the panel should not get buttons on every card by side effect. `ASK`
 * is still required — the summaries run through the same gateway, so an org without Ask
 * has nothing to summarize with.
 */
export function useAiSummariesEnabled(): boolean {
  const isAskEnabled = useFeatureFlag(ASK);
  const areSummariesEnabled = useFeatureFlag(ASK_SUMMARIES);
  return isAskEnabled && areSummariesEnabled;
}
